module.exports = __webpack_public_path__ + "static/media/sf-certified-16.93577405.svg";